import { ChartSetup } from "./enrollment.chart-controller";

var Highcharts = require('highcharts/highcharts');
require('highcharts/highcharts-more')(Highcharts);


export class DrilldownChartBar {
    constructor() {

    }


    UpdateChart(chartSetup: ChartSetup, xAxisLabel: string, yAxisLabel: string, xLabels: string[]): void {
        Highcharts.chart('total-enrollment-modal-chart', {
            chart: {
                type: 'bar',
            },
            credits: { enabled: false },
            title: { text: null },
            xAxis: {
                tickInterval: 1,
                type: "category",
                categories: xLabels,
                title: { text: xAxisLabel },
            },
            yAxis: {
                title: { text: yAxisLabel },
                reversedStacks: false
            },
            plotOptions: {
                bar: {
                    stacking: "normal"
                }
            },
            legend: {
                align: 'center',
                verticalAlign: 'top',
                layout: 'horizontal'
            },
            series: chartSetup.series
        });
    }
}